import styled, { css, CSSProp } from 'styled-components';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { PlanAttributeType } from 'types/productServiceV2';

export const AttributeCardWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

export const AttributeCardStyled = styled.div<{ $planType: PlanAttributeType }>`
  /* Layout */
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.5rem 2.5rem;
  min-height: 3.6rem;

  /* Style */
  color: ${colors.neutral[900]};
  background-color: ${colors.neutral.white};
  box-shadow: ${boxShadows.dark[4]};
  border-radius: 0 0 0.5rem 0.5rem;
  border-top: ${({ $planType }): string => {
    switch ($planType) {
      case 'FILLED_COVERED':
        return `6px solid ${colors.green[600]}`;
      case 'FILLED_UNCOVERED':
        return `6px solid ${colors.neutral[300]}`;
      case 'UNFILLED':
        return `6px solid ${colors.red[600]}`;
      default:
        return `6px solid ${colors.red[600]}`;
    }
  }};
`;

export const TitleStyled = styled(Button)`
  font-weight: 700;
  font-size: 2rem;
  line-height: 3.2rem;
  color: ${colors.neutral[900]};
  text-transform: none;
  padding: 0;
`;

export const AttributeHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const AttributeAnswersStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${colors.neutral[900]};
`;

export const AttributeListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const ProductOfferingStyled = styled.b`
  margin-bottom: 0.5rem;
`;

export const LabelStyled = styled.span`
  display: grid;
  grid-template-columns: 8rem 1fr;
  gap: 1rem;
`;

export const LabelKeyStyled = styled.b`
  color: ${colors.neutral[700]};
`;

export const SectionStyled = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-left: 4rem;
  overflow: hidden;
  transition: 0.3s ease;

  ${({ $isOpen }): CSSProp => {
    if ($isOpen) {
      return css`
        margin-top: 3rem;
        max-height: none;
        opacity: 1;
      `;
    }
    return css`
      margin-top: 0;
      max-height: 0;
      opacity: 0;
    `;
  }};
`;

export const MaxWaiverLabelStyled = styled.span`
  margin-top: 1rem;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${colors.neutral[900]};

  & b {
    color: ${colors.neutral[700]};
  }
`;

export const RemoveAttributeButtonStyled = styled(Button)`
  &:disabled {
    background-color: transparent;
    color: ${colors.neutral[600]};
  }
`;
